export class Redes
{
    public id_rede: number = 0;
    public nome_rede: string = '';
    public icone_rede?: Uint32Array = undefined;
    public id_tpct: number = 0;
}